import { APIService } from "services";

const designationlevelId = parseInt(localStorage.getItem("desig_level_id"));
const vibahgId = localStorage.getItem("vibhag_id");
const zillId = localStorage.getItem("zill_id");
const nagarkhandId = localStorage.getItem("nagar_khanda_id");
const upamandabastiId = localStorage.getItem("upamandal_basti_id");

export const getSamithi_Members = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllSamithi_Members(pageNo,pageSize);
    }
    else{
        try {
            res = await searchSamithi_Members(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data){
    return res.data;
    }else{
    return { records:[], totalCount:0 }
    }
    
}


export const addSamithi_Members = (data) => {
return APIService.api().post(`/samithi_members`,data)
}
export const updateSamithi_Members = (samithi_member_id,data) => {
return APIService.api().post(`/samithi_members/update`,data)
}
export const getAllSamithi_Members = (pageNo,pageSize) => {
    if(designationlevelId == 1){
    return APIService.api().post(`/samithi_members/searchWithFields`, {"stayi":"1"})
}else if(designationlevelId == 2){ 
    return APIService.api().post(`/samithi_members/searchWithFields`,{"stayi":"2"})
}else if(designationlevelId == 3){  
    return APIService.api().post(`/samithi_members/searchWithFields`,{"stayi":"3", vibhag:vibahgId })
}else if(designationlevelId == 4){
    return APIService.api().post(`/samithi_members/searchWithFields`,{"stayi":"4", zilla:zillId})
}else if(designationlevelId == 5){
    return APIService.api().post(`/samithi_members/searchWithFields`,{"stayi":"5", nagar_khanda:nagarkhandId})
}else if(designationlevelId == 6){
    return APIService.api().post(`/samithi_members/searchWithFields`,{"stayi":"6", upamandal_basti:upamandabastiId})
}
}
export const getOneSamithi_Members = (samithi_member_id) => {
return APIService.api().get(`/samithi_members/${samithi_member_id}`)
}
export const searchSamithi_Members = (data,pageNo,pageSize) => {
return APIService.api().post(`/samithi_members/searchWithFields`, data)
}
export const deleteSamithi_Members = (samithi_member_id) => {
return APIService.api().post(`/samithi_members/delete`, samithi_member_id)
}
